import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

// Kích thước avatar dùng chung cho bình luận gốc (md, 40px) và trả lời (sm, 28px)
const SIZE_CLASSES = {
    md: 'h-10 w-10 min-w-[40px] text-base',
    sm: 'h-7 w-7 min-w-[28px] text-xs',
};

function CommentAvatar({ avatar, isAdmin, size = 'md' }) {
    const dimension = SIZE_CLASSES[size] || SIZE_CLASSES.md;

    return (
        <div className="relative shrink-0">
            <div
                className={`${dimension} rounded-full overflow-hidden flex justify-center items-center bg-surface-raised ${
                    isAdmin ? 'ring-2 ring-primary-500' : ''
                }`}
            >
                {avatar ? (
                    <img
                        className="h-full w-full object-cover"
                        src={`${process.env.REACT_APP_API_PUBLIC_URL}/img/users/${avatar}`}
                        alt="avt"
                    />
                ) : (
                    <FontAwesomeIcon icon={faUser} className="text-content-3" />
                )}
            </div>
            {/* Bỏ badge "QTV" ở góc avatar: bị tràn ra ngoài trông như lỗi CSS,
                và cạnh tên đã có badge rank "Admin" nên thừa thông tin. Admin
                vẫn nhận diện bằng ring cam quanh avatar. */}
        </div>
    );
}

export default CommentAvatar;
